export const SET_QUESTION_GENERATOR_DATA: string =
  'SET_QUESTION_GENERATOR_DATA';
export const RESET_QUESTION_GENERATOR_DATA: string =
  'RESET_QUESTION_GENERATOR_DATA';
export const UPDATE_ANSWER: string = 'UPDATE_ANSWER';
